import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../../components/common';
import { HELP_LINKS } from '../../../../constants/HelpLinks';
import { IOuter } from '../EmptyState.types';

export const NotAuthorizedSubtitle: FC<IOuter> = () => (
  <FormattedMessage
    id="empty-state.not-authorized-subtitle"
    values={{
      wixComLink: (
        <TextButton as="a" size="small" target="_blank" href={HELP_LINKS.WIX_COM}>
          <FormattedMessage id="empty-state.not-authorized-subtitle-wixcom" />
        </TextButton>
      ),
    }}
  />
);

export const NewNotAuthorizedSubtitle: FC<IOuter> = () => (
  <FormattedMessage
    id="empty-state.not-authorized-subtitle-new"
    values={{
      wixComLink: (
        <TextButton as="a" size="small" target="_blank" href={HELP_LINKS.WIX_COM}>
          <FormattedMessage id="empty-state.not-authorized-subtitle-wixcom" />
        </TextButton>
      ),
    }}
  />
);
